import type {
    TitlesSelectionProps,
} from "../../contacts-search-profiles/components/TitlesSelection/TitlesSelection";
import TitlesSelection from "../../contacts-search-profiles/components/TitlesSelection/TitlesSelection";

type ExcludedTitlesProps = Pick<TitlesSelectionProps, "selectedItems" | "id"> & {
    onChange(titles: string[]): void;
};

const ExcludedTitles = ({ onChange, ...rest }: ExcludedTitlesProps) => {
    function handleAdd(title: string) {
        onChange(rest.selectedItems.concat(title));
    }

    function handleRemove(title: string) {
        onChange(rest.selectedItems.filter((t) => t !== title));
    }

    return (
        <TitlesSelection
            {...rest}
            onAdd={handleAdd}
            onRemove={handleRemove}
            label={{ key: "si.account-overview.employee-profiles.exclude-titles.text" }}
        />
    );
}

export default ExcludedTitles;
